import { LoadState } from "../../constants/enums";
import { ICampaign, ICampaignState } from "./campaign.types";

export const initialCallCampaign: ICampaign = {
  campaign_uuid: "",
  campaign_name: "",
  campaign_data_type: "",
  comment: "",
  status: "ACTIVE",
  assign_type: "round_robin",
  assign_rule: {
    strategy: "",
    target_type: "user",
    roles: [],
    users: []
  },
  emitsocket: 1,
  company_outlet_uuid: "",
  campaign_rule_template_uuid: null,
  campaign_rule_template_name: null,
  campaign_rule_template_selected_variables: null,
  is_template: 0,
  campaign_data_source: null,
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: ""
};

export const initialCampaignState: ICampaignState = {
  Campaign: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null
    }
  }
};
